import { curry, filter, reverse, sortBy, uniqBy } from 'lodash';
import { IStrategy, IAsset, IStrategyAsset } from '../../../types/model';
import { Currency } from '../../../types/common';
import { compose } from 'lodash/fp';
import { TUIMode } from '../../../types/model';

/**
 *
 * @returns strategy assets or empty array
 */
function selectStrategyAssets(
  strategy: IStrategy | undefined
): IStrategyAsset[] {
  if (!strategy) return [];
  return strategy.strategyAssets?.items || [];
}

export function getActualAssets(arg: IStrategyAsset[]) {
  return arg.map(({ asset }) => asset);
}

export function getStrategyAssets(strategy: IStrategy) {
  return compose(
    removeDuplicates,
    filterOutNullExchanges,
    getActualAssets,
    sortAssetsByValue(strategy?.currency || 'EUR'),
    selectStrategyAssets
  )(strategy);
}

/*
 * @returns StrategyAsset array sorted by value (unit * price)
 * */
export const sortAssetsByValue = curry(
  (currency: Currency['code'], assets: IStrategyAsset[]) => {
    return reverse(
      sortBy(assets, [
        function (asset) {
          return (
            asset.unit * asset.asset.history[0][currency.toLocaleLowerCase()]
          );
        },
      ])
    );
  }
);

/*
 * @returns StrategyAssets[] where exchange field is set
 * */
export function filterOutNullExchanges(assets: IAsset[]) {
  return filter(assets, function (asset) {
    return asset.exchange !== null;
  });
}

/*
 * Remove duplicate assets
 * */
export function removeDuplicates(assets: IAsset[]): IAsset[] {
  return uniqBy(assets, (asset) => asset.id);
}

/*
 * Constructs the URI to pass iframe
 */
export function getURI({
  interval,
  exchangeSymbol,
  theme,
}: {
  interval: string;
  exchangeSymbol: string;
  theme: Lowercase<TUIMode>;
}): string {
  const percent = encodeURIComponent('%');
  return `https://s.tradingview.com/embed-widget/technical-analysis/?locale=en&interval=${interval}&width=100${percent}&isTransparent=true&height=260&symbol=${exchangeSymbol}&showIntervalTabs=true&colorTheme=${theme}`;
}
